// extracted by mini-css-extract-plugin
module.exports = {"Post":"Post_Post__y18Vk","Title":"Post_Title__iKyDh","Excerpt":"Post_Excerpt__yMdge","Tags":"Post_Tags__we__h","Tag":"Post_Tag__D57Ir","Arrow":"Post_Arrow__jth_i"};